import classNames from 'classnames/bind';
import styles from './EbookActivityDetails.module.css';
import { PageSummary as PageSummaryType } from '../../../types/analysis';
import {
  NO_RECENT_LEARNING_PAGE,
  SUMMARIZING_PAGE,
  PLEASE_RETRY_LATER,
  SUMMARIZING_PAGE_ERROR,
  RECENT_LEARNING_AI_DISCLAIMER,
} from '../../../constants';
import { DATA_STATUS } from '../../../constants/config';

const cx = classNames.bind(styles);

interface PageSummaryProps {
  summaryData?: PageSummaryType;
}

export default function PageSummary({ summaryData }: PageSummaryProps) {
  if (!summaryData) return null;

  const status = summaryData.status;

  if (status === DATA_STATUS.NO_DATA) {
    return (
      <div className={cx('summary_container', 'no_data')}>
        <p>{NO_RECENT_LEARNING_PAGE}</p>
      </div>
    );
  }

  if (status === DATA_STATUS.LOADING) {
    return (
      <div className={cx('summary_container')}>
        <div className={cx('loading_indicator')}>
          <div>
            <p>{SUMMARIZING_PAGE}</p>
            <p>{PLEASE_RETRY_LATER}</p>
          </div>
        </div>
      </div>
    );
  }

  if (status === DATA_STATUS.ERROR) {
    return (
      <div className={cx('summary_container')}>
        <div className={cx('loading_indicator', 'error_state')}>
          <div>
            <p>{SUMMARIZING_PAGE_ERROR}</p>
            <p>{PLEASE_RETRY_LATER}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={cx('summary_container')}>
      <div className={cx('summary')}>{summaryData.summary}</div>
      <p className={cx('subtext')}>※ {RECENT_LEARNING_AI_DISCLAIMER}</p>
    </div>
  );
}
